import { Outlet } from "react-router-dom";

export default function Admin(){
    return(
        <div className="wrapper admin">
            <Outlet/>
        </div>
    )
}